import { toast } from "react-toastify"

import { useLazyDeleteVendorOrderQuery } from "store/api/adminApi"
import { useAppSelector } from "store/hooks"

import getErrorMessage from "utils/getErrorMessage"

import { DeleteModal } from "../DeleteModal"

interface Props {
  onCancel: () => void
  onSuccess: () => void
}

export const DeleteOrderModalForVendorOld = ({ onCancel, onSuccess }: Props) => {
  const [triggerDeleteVendorOrder, { isFetching }] = useLazyDeleteVendorOrderQuery()
  const currentOrder = useAppSelector(state => state.tempData.currentOrder)

  const onSubmit = async (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault()

    try {
      const res = await triggerDeleteVendorOrder(currentOrder?.id as unknown as number)
      const error = getErrorMessage(res?.error)
      if (error) {
        toast.error(error)
      } else {
        toast.success("Order has been successfully deleted!")
        onSuccess()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <DeleteModal
      title="Delete order"
      message="Are you sure you want to delete the selected order(s)?"
      isFetching={isFetching}
      onCancel={onCancel}
      onConfirm={onSubmit}
    />
  )
}
